import React from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

const DataTableProductsDepot = ({
  products,
  title,
  icon = "fas fa-boxes",
  color = "#343a40",
}) => {
  const { SearchBar } = Search;

  const numberOrZero = (value) =>
    value !== null && value !== undefined ? value : 0;

  const columns = [
    {
      dataField: "product.barcode",
      text: "Code à barre",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "product.name",
      text: "Libellé",
      headerAlign: "center",
      formatter: (cell) => <strong>{cell}</strong>,
    },
    {
      dataField: "quantity",
      text: "Quantité",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => (
        <span className="badge text-white" style={{ backgroundColor: color }}>
          {numberOrZero(cell)}
        </span>
      ),
    },
    {
      dataField: "qteMin",
      text: "Quantité min",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => numberOrZero(cell),
    },
    {
      dataField: "qteMax",
      text: "Quantité max",
      align: "center",
      headerAlign: "center",
      formatter: (cell) => numberOrZero(cell),
    },
    {
      dataField: "gap",
      text: "Écart",
      isDummyField: true,
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => {
        const quantity = numberOrZero(row.quantity);
        const min = numberOrZero(row.qteMin);
        const max = numberOrZero(row.qteMax);
        if (quantity < min)
          return (
            <span style={{ color: "#dc3545", fontWeight: 600 }}>
              {quantity - min}
            </span>
          );
        if (max > 0 && quantity > max)
          return (
            <span style={{ color: "#28a745", fontWeight: 600 }}>
              +{quantity - max}
            </span>
          );
        return <span className="text-muted">-</span>;
      },
    },
  ];

  const options = {
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "25", value: 25 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
    ],
    pageButtonRenderer: ({ page, active, onPageChange }) => {
      const handleClick = (e) => {
        e.preventDefault();
        onPageChange(page);
      };
      return (
        <li className="page-item">
          <button
            className="btn btn-sm"
            onClick={handleClick}
            style={
              active
                ? { backgroundColor: "#343a40", color: "white" }
                : { backgroundColor: "white", color: "#343a40" }
            }
          >
            {page}
          </button>
        </li>
      );
    },
  };

  return (
    <div
      className="card mb-4"
      style={{
        borderRadius: 8,
        boxShadow: "0 1px 6px rgba(0,0,0,.08)",
        borderTop: `3px solid ${color}`,
      }}
    >
      <div className="card-header">
        <h3 className="card-title">
          <i className={`${icon} mr-2`} style={{ color }}></i>
          {title}
          <span
            className="badge ml-2 text-white"
            style={{ backgroundColor: color }}
          >
            {products ? products.length : 0}
          </span>
        </h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={products}
          columns={columns}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0 mb-3">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  />
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  headerClasses="thead-light"
                  wrapperClasses="table-responsive w-100"
                  striped
                  hover
                  condensed
                  noDataIndication={() => (
                    <div className="text-center text-muted py-4">
                      <i className="fas fa-box-open fa-2x mb-2 d-block"></i>
                      Aucun produit
                    </div>
                  )}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>
  );
};

export default DataTableProductsDepot;
